module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.entity,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编码",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "不填写由系统生成"
    },
    model: {
      value: (_vm.entity.code),
      callback: function($$v) {
        _vm.$set(_vm.entity, "code", $$v)
      },
      expression: "entity.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.name),
      callback: function($$v) {
        _vm.$set(_vm.entity, "name", $$v)
      },
      expression: "entity.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "免费时长",
      "prop": "freeMinutes"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "11"
    },
    model: {
      value: (_vm.entity.freeMinutes),
      callback: function($$v) {
        _vm.$set(_vm.entity, "freeMinutes", _vm._n($$v))
      },
      expression: "entity.freeMinutes"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("分钟")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在区域",
      "prop": "areaCode"
    }
  }, [_c('area-cascader', {
    model: {
      value: (_vm.entity.areaCode),
      callback: function($$v) {
        _vm.$set(_vm.entity, "areaCode", $$v)
      },
      expression: "entity.areaCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.address),
      callback: function($$v) {
        _vm.$set(_vm.entity, "address", $$v)
      },
      expression: "entity.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地理位置",
      "prop": "lng"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "经度"
    },
    model: {
      value: (_vm.entity.lng),
      callback: function($$v) {
        _vm.$set(_vm.entity, "lng", $$v)
      },
      expression: "entity.lng"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "维度"
    },
    model: {
      value: (_vm.entity.lat),
      callback: function($$v) {
        _vm.$set(_vm.entity, "lat", $$v)
      },
      expression: "entity.lat"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "0 5px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "el-icon-location",
    attrs: {
      "type": "text",
      "title": "选择位置"
    },
    on: {
      "click": _vm.selectLocation
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.entity.status),
      callback: function($$v) {
        _vm.$set(_vm.entity, "status", $$v)
      },
      expression: "entity.status"
    }
  }, _vm._l((_vm.$dict.store.STATUS), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('v-image-uploader', {
    attrs: {
      "form-data": {}
    },
    model: {
      value: (_vm.entity.logo),
      callback: function($$v) {
        _vm.$set(_vm.entity, "logo", $$v)
      },
      expression: "entity.logo"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            LOGO\n          ")])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.entity.remark),
      callback: function($$v) {
        _vm.$set(_vm.entity, "remark", $$v)
      },
      expression: "entity.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    ref: "mapDiag",
    attrs: {
      "title": "选择位置",
      "append-to-body": true
    }
  }, [_c('a-map-location', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    on: {
      "location-click": _vm.onLocationClick
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3037f13e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/parkInfo/Form.vue
// module id = 321
// module chunks = 0